export const localKeyGenByVedaPositionsOfSpaceField = 'KeyGenByVedaPositionsOfSpaceField';
